/* eslint-disable require-unicode-regexp */
import { EmergencyNotificationSMSConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { foldToASCII } from '~libs.typescript';

export const getFullMessage = (
   smsConfiguration: EmergencyNotificationSMSConfiguration,
   messageCustomizablePart: string | null | undefined
): string => {
   return `${smsConfiguration.messageSenderPart}\n\n${foldToASCII(messageCustomizablePart ?? '')}
   `;
};
